import type { Area } from '@common/types/Area'
import { mapOrd, rawOrd } from '@lc/libarray'
import {
	createEntityAdapter,
	createSlice,
	type WithSlice,
} from '@reduxjs/toolkit'
import { reducer } from './store'

export const areasAdapter = createEntityAdapter({
	selectId: (area: Area) => area.id,
	sortComparer: mapOrd(rawOrd, area => area.id),
})

const { selectById, selectIds, selectEntities } = areasAdapter.getSelectors()

declare module './store' {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	export interface LoadedSlices extends WithSlice<typeof areasSlice> {}
}

export type AreasSlice = ReturnType<(typeof areasSlice)['getInitialState']>
export const areasSlice = createSlice({
	name: 'areas',
	initialState: areasAdapter.getInitialState<{
		hoveredArea: string | null
	}>({ hoveredArea: null }),
	reducers: {
		setArea: areasAdapter.setOne,
		setAreas: areasAdapter.setMany,

		delArea: areasAdapter.removeOne,
		delAreas: areasAdapter.removeMany,

		insertAreas: areasAdapter.addMany,

		clearAreas: areasAdapter.removeAll,
		initAreas: areasAdapter.setAll,
		// setHoveredArea: (state, action: PayloadAction<string | null>) => {
		// 	state.hoveredArea = action.payload
		// },
	},
	selectors: {
		getAllAreas: selectEntities,
		getArea: (state, id: string): Area | undefined => selectById(state, id),
		listAreas: selectIds,
		getHoveredAread: state => state.hoveredArea,
	},
})

export const {
	reducer: areasReducer,
	actions: {
		setArea,
		setAreas,
		delArea,
		delAreas,
		insertAreas,
		clearAreas,
		initAreas,
		// setHoveredArea,
	},
	selectors: { getArea, listAreas, getAllAreas, getHoveredAread },
} = areasSlice.injectInto(reducer)
